import React from 'react';
import { useQuery } from '@apollo/client';
import { readAllDepartments } from './api';
import { useSelector } from 'react-redux';

interface Props {
  formik: any;
}

const DepartmentDropdown = (props: Props) => {
  const { loading, error, data } = useQuery(readAllDepartments);
  const { userDepartmentName } = useSelector((state: any) => ({
    userDepartmentName: state.user.currentRole.department.Name,
  }));

  if (loading) return null;
  if (error) return <div>error</div>;
  return (
    <div className='form-group form-inline'>
      <label className='col-sm-3'>Department</label>
      <select
        className='form-control col-sm-8'
        id='itemDepartment'
        name='itemDepartment'
        onChange={props.formik.handleChange}
        value={props.formik.values.itemDepartment}
        defaultValue={userDepartmentName}>
        {data.readAllDepartments.map((department: any, index: number) => {
          return (
            <option key={index} value={department.Name} selected={department.Name === userDepartmentName}>
              {department.Name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default DepartmentDropdown;
